import React, { useState } from "react";
import "./FilterModalCRM.scss";
import BaseModal from "../UI/BaseModal/BaseModal";
import { useSelector } from "react-redux";
import Select from "../UI/Select/Select";
import { Box, Typography, Button } from "@mui/material";

function FilterModalCRM({
  handleClose,
  open,
  userHeader,
  setFilter,
  setCountryFilter,
  filters
}) {
  // State to track the currently active filter
  const [activeFilter, setActiveFilter] = useState(null);

  // Function to set both the active filter for highlighting and the filter for functionality
  const handleFilterClick = (filter) => {
    setActiveFilter(filter); // Set the active filter for highlighting
    setFilter(filter); // Set the filter for the parent component's logic
  };

  const countries = useSelector(
    (state) => state.constants.formSelectData.country
  );

  const handleCountryFilter = (e) => {
    setCountryFilter(e.target.value);
  };

  return (
    <BaseModal
      handleClose={handleClose}
      open={open}
      width={"60%"}
      //   baseHeight={500}
      headerText={userHeader}
    >
      <Box className="filter-modal-container">
        <Box className="filter-modal-header"></Box>
        <Box className="filter-modal-body">
          <Box className="filter-modal-section">
            <Typography>Filter by User Status</Typography>
            <Box className="filter-buttons d-flex gap-2">
              {["Unverified", "Active", "KYC Uploaded", "KYC Approved", "No Password"].map(
                (filter, index) => (
                  <Button
                    key={index}
                    className={filter == activeFilter ? "highlighted" : ""}
                    onClick={() => handleFilterClick(filter)}
                    sx={{ textTransform: 'none' }}
                  >
                    {filter}
                  </Button>
                )
              )}
            </Box>
          </Box>

          <Box className="filter-modal-section">
            <Typography>Filter by Country</Typography>
            <Box className="filter-buttons d-flex gap-2">
              <Select
                options={countries}
                onChange={(e) => handleCountryFilter(e)}
              />
            </Box>
          </Box>
          {/* <Box className="filter-modal-section">
            <Typography>Filter by User Role</Typography>
            <Box className="filter-buttons d-flex gap-2">
              {["Super Admin", "Admin", "User"].map((filter, index) => (
                <Button 
                  key={index}
                  sx={{ textTransform: 'none' }}
                >
                  {filter}
                </Button>
              ))}
            </Box>
          </Box> */}
        </Box>
      </Box>
    </BaseModal>
  );
}

export default FilterModalCRM;
